import { useTranslation } from 'react-i18next';
import { OutlineChat } from './OutlineChat';
import { OutlineTreeEditor } from './OutlineTreeEditor';
import { parseOutline, type OutlineNode } from '../../data/outline';

interface OutlineBuilderProps {
  value: string;
  onChange: (value: string) => void;
  /** Other already-resolved property values, so the chat can ground its suggestions in them. */
  context: Record<string, string>;
}

/** Composes the chat and tree editor over one shared outline state, serialized as the field's JSON value. */
export function OutlineBuilder({ value, onChange, context }: OutlineBuilderProps) {
  const { t } = useTranslation();
  const outline = parseOutline(value);

  const setOutline = (next: OutlineNode[]) => onChange(JSON.stringify(next));

  return (
    <div className="mt-2 grid gap-4 lg:grid-cols-2">
      <div>
        <h3 className="mb-2 text-sm font-semibold text-foreground">{t('outline.chat.title')}</h3>
        <OutlineChat onOutlineChange={setOutline} context={context} />
      </div>
      <div>
        <h3 className="mb-2 text-sm font-semibold text-foreground">{t('outline.tree.title')}</h3>
        <OutlineTreeEditor outline={outline} onChange={setOutline} />
      </div>
    </div>
  );
}
